export default {
  title: 'Persoonlijke gegevens',
  buttons: {
    save: 'Opslaan',
  },
  toasts: {
    personal_info_updated_successfully: 'Uw gegevens zijn succesvol opgeslagen',
  },
};
